import {
  Stack,
  Box,
  Text,
  Button,
  Link,
  Alert,
  AlertIcon,
  AlertContent,
  AlertTitle,
  AlertBodyText,
} from '@nike/podium';
import { useAccounts } from '../hooks/useAccounts';
import { redirectToAccount } from '../utils/redirect';
import AccountDrawer from './AccountDrawer';
import LoadingButton from './LoadingButton';

export default function Main() {
  const { accounts, isLoading, error } = useAccounts();

  return (
    <Box pl={60} pr={60}>
      <Stack gap="xl">
        <Box mt={10}>
          <Text font="display-5" as="h1">AWS Management Console</Text>
          <Box
            padding={24}
            style={{ backgroundColor: 'var(--pds-color-white)', border: '1px solid var(--pds-color-grey-200)' }}
          >
            <Stack horizontal gap="l" wrap align="center">
              <Box style={{ flex: '1 1 70%', minWidth: '300px' }} pr={60}>
                <Text font="body-1" as="p">
                  Select an Amazon Web Services account from the list at the right to access the AWS Management Console. The list is populated with
                  all of the AWS accounts that you have been granted access to. If you have access to multiple roles within an account, you can choose between them on the next page.
                  {' '}
                  <Text font="body-1-strong" as="strong">
                    Multi-Factor Authentication is required for access to all Nike
                    AWS Accounts.
                  </Text>
                </Text>
              </Box>
              <Box style={{ flex: '0 0 25%', minWidth: '200px' }}>
                {isLoading ? (
                  <LoadingButton />
                ) : error ? (
                  <Text font="body-1" as="p">{error}</Text>
                ) : accounts.length === 0 ? (
                  <Text font="body-1" as="p">No AWS accounts found.</Text>
                ) : accounts.length === 1 ? (
                  <Button
                    variant="filled"
                    style={{ width: '100%' }}
                    onClick={() => redirectToAccount(accounts[0])}
                  >
                    {accounts[0].name}
                  </Button>
                ) : (
                  <AccountDrawer
                    accounts={accounts}
                    onSelect={redirectToAccount}
                  />
                )}
              </Box>
            </Stack>
          </Box>
        </Box>

        <Box>
          <Alert>
            <AlertIcon>
              <span style={{ fontSize: '20px' }}>⌨️</span>
            </AlertIcon>
            <AlertContent>
              <AlertTitle>Need CLI access?</AlertTitle>
              <AlertBodyText>
                Use{' '}
                <Link
                  href="https://github.com/Nike-Inc/gimme-aws-creds"
                  font="body-2"
                  underline
                >
                  gimme-aws-creds
                </Link>{' '}
                to get temporary AWS security credentials for command-line tools. {' '}
                <Link
                  href="https://confluence.nike.com/pages/viewpage.action?spaceKey=IAM&title=Gimme-AWS-Creds"
                  font="body-2-strong"
                  underline
                  style={{ marginLeft: '14px' }}
                >
                  View the Nike setup guide →
                </Link>
              </AlertBodyText>
            </AlertContent>
          </Alert>
        </Box>
      </Stack>
    </Box>
  );
}
